import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi everyone! I’m <span className="purple">Dinh Nhat Thong</span>{" "}
            from <span className="purple">Ho Chi Minh, Viet Nam</span>.
            <br />
            I’m a <span className="purple">Backend Developer</span> focused on
            backend engineering, DevOps workflows, and data-driven systems.
            <br />I enjoy designing high-availability architectures with{" "}
            <span className="purple">Node.js, NestJS, ASP.NET Core</span>, and
            modern cloud tooling.
            <br />
            <br />I love solving real product problems and turning complex
            requirements into simple, scalable APIs.
          </p>

          <ul>
            <li className="about-activity">
              <ImPointRight /> Building resilient backend systems
            </li>
            <li className="about-activity">
              <ImPointRight /> Automating workflows with DevOps mindset
            </li>
            <li className="about-activity">
              <ImPointRight /> Exploring AI and data engineering use-cases
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "I don't chase trends, I ship systems that scale."{" "}
          </p>
          <footer className="blockquote-footer">Dinh Nhat Thong</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
